// Importing necessary hooks and functions from React
import React, { createContext, useContext, useState } from 'react';

// Creating a new context named SearchContext
const SearchContext = createContext();

// Custom hook to access the SearchContext, making it easier to use in components
export const useSearch = () => {
  return useContext(SearchContext);
};

// Provider component to wrap parts of the application that need access to search-related state
export const SearchProvider = ({ children }) => {
  // State variable to store the current search term and function to update it
  const [searchTerm, setSearchTerm] = useState('');

  return (
    // Providing searchTerm and setSearchTerm to any component that consumes SearchContext
    <SearchContext.Provider value={{ searchTerm, setSearchTerm }}>
      {children} {/* Rendering children components within the provider */}
    </SearchContext.Provider>
  );
};
